"use strict";
/**
 * Currently representing API DTOs in their JSON form.
 */
exports.__esModule = true;
